import {
  MODEL_PORTFOLIOS_GET,
  MODEL_PORTFOLIOS_HOLDINGS_GET,
  MODEL_PORTFOLIOS_KPIS_GET,
  MODEL_PORTFOLIOS_PERFORMANCES_GET,
  MODEL_PORTFOLIOS_WITH_KPIS_GET,
  MODEL_PORTFOLIOS_DETAILS_GET,
  MODEL_PORTFOLIOS_MAX_DRAWDOWN_GET,
} from '../actions/types';

const initialState = {
  items: undefined,
  itemsByRiskProfiles: {},
  holdings: {},
  kpis: {},
  performances: {},
  sectorAllocation: {},
  geoAllocation: {},
  assetClassAllocation: {},
  currencies: {},
  maxDrawdowns: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MODEL_PORTFOLIOS_GET._SUCCESS: {
      const { modelPortfolios, riskProfileId } = action.payload;
      if (riskProfileId) {
        state.itemsByRiskProfiles[riskProfileId] = modelPortfolios;
      } else {
        state.items = modelPortfolios;
      }
      return state;
    }
    case MODEL_PORTFOLIOS_WITH_KPIS_GET._SUCCESS: {
      const { modelPortfolios, modelPortfoliosKpis } = action.payload;

      modelPortfoliosKpis.forEach((kpis, i) => {
        const modelPortfolioId = modelPortfolios[i]?.id;
        state.kpis[modelPortfolioId] = kpis;
      });

      state.items = modelPortfolios;
      return state;
    }
    case MODEL_PORTFOLIOS_HOLDINGS_GET._SUCCESS: {
      const { modelPortfolioId, holdings } = action.payload;
      state.holdings[modelPortfolioId] = holdings;
      return state;
    }
    case MODEL_PORTFOLIOS_DETAILS_GET._SUCCESS: {
      const { modelPortfolioId, modelPortfolio } = action.payload;
      state.sectorAllocation[modelPortfolioId] = modelPortfolio.sectorAllocation;
      state.geoAllocation[modelPortfolioId] = modelPortfolio.geoAllocation;
      state.assetClassAllocation[modelPortfolioId] = modelPortfolio.assetClassAllocation;
      state.currencies[modelPortfolioId] = modelPortfolio.currencies;
      return state;
    }
    case MODEL_PORTFOLIOS_KPIS_GET._SUCCESS: {
      const { modelPortfolioId, kpis } = action.payload;
      state.kpis[modelPortfolioId] = kpis;
      return state;
    }
    case MODEL_PORTFOLIOS_PERFORMANCES_GET._SUCCESS: {
      const {
        modelPortfolioId,
        performanceChartYearsTag,
        performanceChartBenchmarkId,
        performanceChart,
        compareIds,
      } = action.payload;

      if (compareIds) {
        state.performances[modelPortfolioId][`compare${compareIds}`] = {
          performanceChartBenchmarkId,
          performanceChart,
          performanceChartYearsTag,
        };
      } else {
        state.performances[modelPortfolioId] = {
          performanceChartBenchmarkId,
          performanceChart,
          performanceChartYearsTag,
        };
      }
      return state;
    }
    case MODEL_PORTFOLIOS_MAX_DRAWDOWN_GET._SUCCESS: {
      const { modelPortfolioId, maxDrawdown } = action.payload;
      state.maxDrawdowns[modelPortfolioId] = maxDrawdown;
      return state;
    }
    default:
      return state;
  }
};

export { reducer as modelPortfolios };
